import React, { useEffect, useState } from "react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { cn } from "@/lib/utils";
import { Inter } from "next/font/google";
import Image from "next/image";
import { Mixpanel } from "@/elements/Mixpanel";
const inter = Inter({
    subsets: ["latin"],
    variable: "--font-inter"
});

export default function SetGTTInfo() {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (open) {
            Mixpanel.track("info_clicked", {
                page: "order_form",
                info_type: "GTT"
            });
        }
    }, [open]);

    return (
        <DropdownMenu open={open} onOpenChange={setOpen}>
            <DropdownMenuTrigger>
                <AiOutlineInfoCircle color="#0862BC" className="text-[14px]" />
            </DropdownMenuTrigger>
            <DropdownMenuContent className={cn("w-80 h-[262px] rounded-2xl p-2 font-Inter shadow-2xl", inter.variable)}>
                <Image
                    src="https://storage.googleapis.com/app-assets-univest/broker_assets/gtt_bf.png"
                    alt="GTT"
                    width={600}
                    height={600}
                    className="w-full"
                    onClick={() => setOpen(!open)}
                />
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
